export const ACTION_NAMES = {
  UPDATE_STATE_CREDIT_APPLICATION: 'UPDATE_STATE_CREDIT_APPLICATION',
};
export const updateCreditApplication = (data) => ({
  type: ACTION_NAMES.UPDATE_STATE_CREDIT_APPLICATION,
  payload: data,
});
